var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisibilityVisible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    rx: 7.5,
    fill: "#DBDFE1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.22112 7.50862C9.22112 8.57462 8.41992 9.38151 7.49996 9.38151C6.58 9.38151 5.77881 8.57462 5.77881 7.50862C5.77881 6.44262 6.58 5.63574 7.49996 5.63574C8.41992 5.63574 9.22112 6.44262 9.22112 7.50862Z",
    stroke: "#899AA3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 3.44043C4.79231 3.44043 2.70513 6.15229 2 7.50823C2.70513 8.86416 4.79231 11.576 7.5 11.576C10.2077 11.576 12.2949 8.86416 13 7.50823C12.2949 6.15229 10.2077 3.44043 7.5 3.44043Z",
    stroke: "#899AA3",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibilityVisible);
export default __webpack_public_path__ + "static/media/visibility_visible.663817a67cbb1372f2e021e6cfc11690.svg";
export { ForwardRef as ReactComponent };